import Image from "~/components/Image";
import {Pagination, Table, Tag} from "antd";
import {
	renderDate,
	numberFormat,
} from "~/utils";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";
import {useUtilities} from "~/hooks";
import SalarySlipAction from "./SalarySlipAction";
import {
	slipTypeLabels,
	calcTypeLabels,
	calcTypeColors
} from "../../constants";

function SalarySlipTable({items = [], pagination, onPaginationChange, setItemEdit, openModal}) {

	const {tableHeight} = useContext(AppContext);

	const {utilities} = useUtilities();

	const paymentLabels = {
		'cod'    : 'Tiền mặt',
		'bank'   : 'Chuyển khoản',
		'momo'   : 'Ví Momo',
		'swipe'  : 'Pos',
	};

	const handleEditClick = (item) => {
		setItemEdit(item);
		openModal('addEdit');
	}

	const handleDeleteClick = (item) => {
		setItemEdit(item);
		openModal('delete');
	}

	const columns = [
		{ title: 'Mã đơn', dataIndex: 'code', key: "code", width: '90px', render: (_, item) => (<div>PL{item?.id}</div>)},
		{ title: 'Kỳ lương', dataIndex: 'salaryMonth', key: "salaryMonth", width: '120px', render: (_, item) => (<div><p>Tháng {renderDate(item?.salaryMonth, 'month')}</p></div>)},
		{ title: 'Ngày chi thực tế', dataIndex: 'paidDate', key: "paidDate", width: '130px', render: (_, item) => (<div><p>{renderDate(item?.paidDate)}</p></div>)},
		{ title: 'Loại phiếu', dataIndex: 'slipType', key: "slipType", width: '160px', render: (_, item) => (<p><b>{slipTypeLabels[item?.slipType] || item?.slipType}</b></p>)},
		{ title: 'Loại tính', dataIndex: 'calcType', key: "calcType", width: '120px', render: (_, item) => (<Tag color={calcTypeColors[item?.calcType]}>{calcTypeLabels[item?.calcType] || item?.calcType}</Tag>)},
		{ title: 'Đối tượng', dataIndex: 'user', key: "user", width: '220px', render: (_, item) => (
			item.user?.id ? (
				<div className="d-flex gap align-items">
					<div className="avatar"><Image src={item.user?.avatar}/></div>
					<div>
						<b>{item.user?.firstname + ' ' + item.user?.lastname}</b>
						<p>{item.user?.username}</p>
					</div>
				</div>
			) : (<Tag color={item?.company?.badge}>{item?.company?.label || 'Công ty'}</Tag>)
		)},
		{ title: 'Số tiền', dataIndex: 'price', key: "price", width: '160px', render: (_, item) => (<p><b>{numberFormat(item?.price)}đ</b></p>)},
		{ title: 'Phương thức', dataIndex: 'paymentMethod', key: "paymentMethod", width: '150px', render: (_, item) => (
			<div>
				<p>{paymentLabels[item?.paymentMethod] || item?.paymentMethod || '--'}</p>
				{item?.paymentMethod === 'bank' && item?.bankAccount && (
					<p style={{fontSize: '12px', color: '#888'}}>{utilities.bankAccounts?.[item.bankAccount]?.title || item.bankAccount}</p>
				)}
			</div>
		)},
		{ title: 'Ghi chú', dataIndex: 'note', key: "note", render: (_, item) => (item?.note)},
		{ title: '#', dataIndex: 'action', key: "action", width: '130px', render: (_, item) => (
			<SalarySlipAction
				key={item.id}
				item={item}
				onClickEdit={handleEditClick}
				onClickDelete={handleDeleteClick}
			/>
		)},
	];

	const dataSource = items.map(row => ({
		key: row.id,
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} dataSource={dataSource} scroll={{ y:tableHeight, x: 'max-content' }} pagination={false} />
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default SalarySlipTable;
